import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Loader from "react-loader-spinner";

// services
import { Mixpanel, MixpanelEvents } from "../../../services/Mixpanel";

// css
import * as styles from "./ReusableForm.module.css";

const ReusableForm = ({
  fields = [],
  onSubmit,
  ctaText = "Submit",
  loading = false,
  mixpanelPageName = "",
  formIsModal = false,
  showCheckbox = true,
  checkboxText = "I agree to be contacted by Twin Health via Call, SMS, RCS, WhatsApp & Email",
  checkboxColor = "#AD2576",
  buttonStyles = {},
  deviceType = "Desktop",
  operatingSystem = "MacOs",
}) => {
  const [formTouched, setFormTouched] = useState(true);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isValid, isSubmitted, isDirty },
  } = useForm({ mode: "all" });

  if (isDirty && formTouched) {
    Mixpanel.track(MixpanelEvents.contact_form_started, {
      page_name: mixpanelPageName,
      form_is_modal: formIsModal,
      device_type: deviceType,
      operating_system: operatingSystem,
      asset: "India Website",
      asset_name: "India Corporate Website",
    });
    setFormTouched(false);
  }

  // Function to handle the form submission
  const handleFormSubmit = async data => {
    // Mixpanel Events
    Mixpanel.track(MixpanelEvents.contact_form_completed, {
      page_name: mixpanelPageName,
      form_is_modal: formIsModal,
      user_name: data.name || data.fullName || "Not Available",
      user_phone: data.phone || data.mobileNumber || "Not Available",
      user_organisation: data.organizationName || "Not Available",
      device_type: deviceType,
      operating_system: operatingSystem,
      asset: "India Website",
      asset_name: "India Corporate Website",
    });

    // Call parent onSubmit
    if (onSubmit) {
      await onSubmit(data);
    }

    // Reset form after successful submission
    reset();
    setFormTouched(true);
  };

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)} className={styles.form}>
      <div className="row g-3">
        {fields.map((field, index) => {
          if (field.hidden) return null;

          return (
            <div
              key={index}
              className={`col-md-${field.colSize || 12} ${styles.formInputBox}`}
            >
              {field.label && (
                <label htmlFor={field.name} className={styles.fieldLabel}>
                  {field.label}
                </label>
              )}
              <input
                type={field.type || "text"}
                placeholder={field.placeholder}
                id={field.name}
                inputMode={field.inputMode}
                maxLength={field.maxLength}
                className={
                  errors[field.name]
                    ? "form-control is-invalid"
                    : "form-control"
                }
                {...register(field.name, field.validation)}
              />
              {errors[field.name] && (
                <span className="invalid-feedback">
                  {errors[field.name].message}
                </span>
              )}
            </div>
          );
        })}

        {showCheckbox && (
          <div className="col-12">
            <div className="form-group mb-3">
              <div className="custom-control">
                <div className="d-flex align-items-start">
                  <input
                    className={`custom-control-input ${styles.checkbox}`}
                    type="checkbox"
                    defaultChecked={true}
                    id="terms-checkbox"
                    style={{
                      borderColor: checkboxColor,
                      accentColor: checkboxColor,
                    }}
                    {...register("terms", {
                      required:
                        "Please check the checkbox to agree to be contacted",
                    })}
                  />
                  <label
                    className={`custom-control-label ${styles.checkLabel}`}
                    htmlFor="terms-checkbox"
                  >
                    {checkboxText}
                  </label>
                </div>
                {errors.terms && (
                  <span className={styles.checkboxInvalid}>
                    {errors.terms.message}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}

        <div className={`col-12 ${styles.formCta}`}>
          <span className="error text-center text-danger">
            {!isValid && isSubmitted}
          </span>
          <div
            className={styles.buttonWrapper}
            style={buttonStyles.width ? { justifyContent: "center" } : {}}
          >
            <button
              type="submit"
              className={styles.submitButton}
              style={{ ...buttonStyles }}
            >
              <span className={loading ? styles.ctaLoader : ""}>{ctaText}</span>
              {loading && (
                <span className={styles.loader}>
                  <Loader
                    type="TailSpin"
                    color="#FFF"
                    height={30}
                    width={30}
                    radius={1}
                    visible={loading}
                  />
                </span>
              )}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default ReusableForm;
